import { createFileRoute, Link } from "@tanstack/react-router";
import headImg from "@/assets/public/story-manufacturing.jpg";
import { PageHead, Shell } from "@/components/public/site";

export const Route = createFileRoute("/shop/")({
  head: () => ({
    meta: [
      { title: "Shop — Maven Scouts Gear" },
      { name: "description", content: "Official Maven Scouts and MavenWERX gear. Coming soon." },
      { property: "og:title", content: "Shop — Maven Scouts Gear" },
      { property: "og:description", content: "Official Maven Scouts and MavenWERX gear. Coming soon." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Shop,
});

const items = ["Maven Scouts Tee", "MavenWERX Hoodie", "Field Cap", "Challenge Coin"];

function Shop() {
  return (
    <Shell>
      <PageHead image={headImg} alt="Gulf South manufacturing floor" code="Shop" title="Maven Scouts Gear" sub="Official Maven Scouts and MavenWERX swag. The store is coming soon." />
      <section className="bg-surface">
        <div className="mx-auto grid max-w-7xl gap-6 px-6 py-20 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((name) => (
            <div key={name} className="border border-border bg-card p-6">
              <div className="blueprint flex aspect-square items-center justify-center bg-navy font-mono text-xs uppercase tracking-widest text-navy-foreground/70">Coming soon</div>
              <p className="mt-4 font-display text-lg uppercase">{name}</p>
            </div>
          ))}
        </div>
        <div className="pb-20 text-center">
          <Link to="/newsletter" className="bg-primary px-8 py-4 font-mono text-xs uppercase tracking-widest text-primary-foreground hover:bg-secondary">Get notified at launch</Link>
        </div>
      </section>
    </Shell>
  );
}
